'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeadRest = function () {
  function LeadRest($http) {
    (0, _classCallCheck3.default)(this, LeadRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      LEADS_LIST: 'leads/',
      LEAD_DETAIL: 'leads/%1$s/',
      DOWNLOAD_LEADS: 'leads/export/',
      INIT_DOWNLOAD: 'leads/_export/',
      SCORE_LEAD: 'leads/%1$s/score_lead/',
      RETRY_DELIVERY: 'leads/%1$s/retry_delivery/'
    };
  }

  (0, _createClass3.default)(LeadRest, [{
    key: 'getList',
    value: function getList(params) {
      return this.$http.get(this.PATH.LEADS_LIST, { params: params });
    }
  }, {
    key: 'getLead',
    value: function getLead(id) {
      return this.$http.get(this.sprintf(this.PATH.LEAD_DETAIL, id));
    }
  }, {
    key: 'initDownload',
    value: function initDownload() {
      return this.$http.post(this.PATH.INIT_DOWNLOAD);
    }
  }, {
    key: 'downloadLeads',
    value: function downloadLeads(params) {
      var querystring = "";

      for (var k in params) {
        if (querystring !== "") {
          querystring += "&";
        }
        querystring += encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
      }
      window.open(this.$http.options.root + "/" + this.PATH.DOWNLOAD_LEADS + "?" + querystring, "_blank");
    }
  }, {
    key: 'scoreLead',
    value: function scoreLead(id) {
      return this.$http.post(this.sprintf(this.PATH.SCORE_LEAD, id));
    }
  }, {
    key: 'retryDelivery',
    value: function retryDelivery(id) {
      return this.$http.post(this.sprintf(this.PATH.RETRY_DELIVERY, id));
    }
  }]);
  return LeadRest;
}();

exports.default = LeadRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/LeadResource.js
// module id = 317
// module chunks = 0